import { useEffect, useRef } from "react";

/* -------------------------------------------------------- */
/* ---- This Function Deep Clone Given Object or Array ---- */
/* -------------------------------------------------------- */

export const customCloneDeep = (inObject) => {
  let outObject, value, key;

  if (typeof inObject !== "object" || inObject === null) {
    return inObject; // Return the value if inObject is not an object
  }

  // Create an array or object to hold the values
  outObject = Array.isArray(inObject) ? [] : {};

  for (key in inObject) {
    value = inObject[key];

    // Recursively (deep) copy for nested objects, including arrays
    outObject[key] = customCloneDeep(value);
  }

  return outObject;
};

/* -------------------------------------------------------- */
/* This Function Finds Value Of Given Key From Given Object */
/* -------------------------------------------------------- */
export const findKey = (KEY, OBJECT) => {
  const keys = Object.keys(OBJECT);
  let result;
  for (const key of keys) {
    if (key === KEY) result = OBJECT[key];
    if (typeof OBJECT[key] === "object") result = findKey(KEY, OBJECT[key]);
    if (result) break;
  }
  return result;
};

/* ------------------------------------------------------------------------ */
/* This Function Round The Given Value To Nearest Multiple Of Given Divisor */
/* ------------------------------------------------------------------------ */
export const roundNearestX = (value, roundTo) => {
  return Math.floor(value / roundTo) * roundTo;
};

/* ------------------------------------------------------------------------ */
/* This Function Gives Array Of Years From given year till Previous Year (current year -1) */
/* ------------------------------------------------------------------------ */
export const getYears = (yearFrom) => {
  let years = [];
  const currentYear = new Date().getFullYear();

  for (let i = yearFrom; i < currentYear; i++) {
    years.push(i);
  }

  return years.reverse();
};

export const handlePhoneNumberInput = (value, previousValue) => {
  // return nothing if no value
  if (!value) return value;

  // only allows 0-9 inputs
  const currentValue = value.replace(/[^\d]/g, "");
  const cvLength = currentValue.length;

  if (!previousValue || value.length > previousValue.length) {
    // returns: "x", "xx", "xxx"
    if (cvLength < 4) return currentValue;

    // returns: "(xxx)", "(xxx) x", "(xxx) xx", "(xxx) xxx",
    if (cvLength < 7)
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;

    // returns: "(xxx) xxx-", (xxx) xxx-x", "(xxx) xxx-xx", "(xxx) xxx-xxx", "(xxx) xxx-xxxx"
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
      3,
      6
    )}-${currentValue.slice(6, 10)}`;
  }
};

export const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value; //assign the value of ref to the argument
  }, [value]); //this code will run when the value of 'value' changes
  return ref.current; //in the end, return the current ref value.
};